module.exports = __webpack_public_path__ + "static/img/areaDeportiva.cb507e9b.jpg";